<template>
    <div v-show="dataShow"
         :style="[{left: (dataX - dataWidth / 2)+'px'}, {top: (dataY - popoverHeight - 10)+'px'}, {'white-space': nowrap ? 'nowrap' : ''}]"
         ref="popover"
         :class="['popover-title',{'down': dataDown},{'nowrap': nowrap},{'pre': preType}]">
        <pre v-if="preType" v-html="dataText"></pre>
        <div v-else v-html="dataText"></div>
        <div ref="popoverAngle" class="popover-angle"></div>
    </div>
</template>

<script>

    export default {
        name: "popover",
        data() {
            return {
                popoverHeight: 0,
                dataWidth: 300,
                dataHeight: "",
                dataText: "",
                dataShow: false,
                dataX: -1000,
                dataY: -1000,
                dataDown: false
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            nowrap: {
                type: Boolean,
                default: false
            },
            preType: {
                type: Boolean,
                default: false
            },
            x: {
                type: [String, Number],
                default: -1000
            },
            y: {
                type: [String, Number],
                default: -1000
            },
            text: {
                type: [String, Number],
                default: null
            },
            height: {
                type: [String, Number],
                default: null
            },
            down: {
                type: Boolean,
                default: false
            },
        },
        created() {
            window.addEventListener("scroll", this.scroll)
        },
        mounted() {
            this.dataShow = this.show;
            this.dataText = this.text;
            this.dataX = this.x;
            this.dataY = this.y;
        },
        methods: {
            scroll() {
                this.dataShow = false
            },
            popoverDown(numb) {
                this.dataDown = true;
                this.dataY = numb + this.dataHeight + 20
            }
        },
        watch: {
            show(val) {
                this.dataShow = val
            },
            text(val) {
                this.dataText = val
            },
            height(val) {
                this.dataHeight = val
            },
            x(val) {
                this.$nextTick(() => {
                    let el = this.$refs.popover;
                    let elAngle = this.$refs.popoverAngle;
                    let elWidth = el.getBoundingClientRect().width;
                    const clientWidth = document.documentElement.clientWidth;
                    if (elWidth - val > elWidth / 2) {
                        this.dataX = (elWidth / 2) + val - 28
                        elAngle.style.left = "16px";
                    } else if (val + elWidth / 2 > clientWidth) {
                        const widthDiffFromCenter = 150 - (clientWidth - val);
                        const widthDiffForAngle = clientWidth - (val - widthDiffFromCenter) + widthDiffFromCenter;
                        this.dataX = clientWidth - (elWidth / 2);
                        elAngle.style.left = (widthDiffForAngle - 10) + "px";
                    } else {
                        this.dataX = val
                        // el.style.transform = "translateX(-50%) translateY(calc(-100% - 10px))";
                        elAngle.style.left = "calc(50% - 10px)";
                        
                    }

                    this.dataWidth = elWidth

                    this.$nextTick(() => {
                        this.popoverHeight = el.getBoundingClientRect().height;
                    })
                })
            },
            y(val) {
                this.dataY = val
                this.$nextTick(() => {
                    let el = this.$refs.popover;
                    let elHeight = el.getBoundingClientRect().height
                    if (val < elHeight || this.down) {
                        this.popoverDown(val + elHeight)
                    } else {
                        this.dataDown = false
                    }
                })
            },
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.scroll)
        }
    }
</script>

<style scoped>
    .popover-title {
        max-width: 300px;
        position: fixed;
        /*transform: translateX(-50%) translateY(calc(-100% - 10px));*/
        display: inline-block;
        background: var(--dark-1-color);
        border-radius: 6px;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        color: var(--white-color);
        padding: 12px;
        z-index: 100;
        text-align: center;
    }
    .popover-title.pre,
    .popover-title.nowrap {
        max-width: none;
    }

    .popover-title .popover-angle{
        position: absolute;
        top: 96%;
        /*position: fixed;*/
        /*bottom: -9px;*/
        left: calc(50% - 10px);
        /*transform: translateX(-50%);*/
        border-top: 10px solid var(--dark-1-color);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
    }

    .down.popover-title .popover-angle {
        top: -9px;
        bottom: unset;
        border-bottom: 10px solid var(--dark-1-color);
        border-top: none;
    }
</style>
